import { lazy } from "react";

export const LandingThirdScreenAsync = lazy(() => import("./LandingThirdScreen"));
